import React from "react";

import { format } from "date-fns";

import { spacing } from "../../tokens";
import { Box } from "../Box/Box";
import { IconButton } from "../IconButton/IconButton";
import { Typography } from "../Typography/Typography";

interface CalendarHeaderProps {
  currentMonth: Date;
  onPrevYear: () => void;
  onPrevMonth: () => void;
  onNextMonth: () => void;
  onNextYear: () => void;
}

export const CalendarHeader: React.FC<CalendarHeaderProps> = ({
  currentMonth,
  onPrevYear,
  onPrevMonth,
  onNextMonth,
  onNextYear,
}) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      mb: spacing.lg,
    }}
  >
    <Box sx={{ display: "flex" }}>
      <IconButton
        onClick={onPrevYear}
        iconProps={{ icon: "anglesLeft", size: "2xs" }}
        size="small"
      />
      <IconButton
        onClick={onPrevMonth}
        iconProps={{ icon: "chevronLeft", size: "2xs" }}
        size="small"
      />
    </Box>

    <Typography variant="titleSmall">
      {format(currentMonth, "MMMM yyyy")}
    </Typography>

    <Box sx={{ display: "flex" }}>
      <IconButton
        onClick={onNextMonth}
        iconProps={{ icon: "chevronRight", size: "2xs" }}
        size="small"
      />
      <IconButton
        onClick={onNextYear}
        iconProps={{ icon: "anglesRight", size: "2xs" }}
        size="small"
      />
    </Box>
  </Box>
);
